var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.calciatoreInAsta
    ? _c(
        "div",
        { staticClass: "assegna" },
        [
          _c(
            "v-card",
            {
              staticClass: "navy asta-assegna-card",
              attrs: { dark: "", elevation: "0" },
            },
            [
              _c("v-card-title", { staticClass: "white--text pt-3 pb-1" }, [
                _c(
                  "span",
                  {
                    staticClass: "asta-assegna-title body-2 font-weight-medium",
                  },
                  [
                    _vm.ruoloCalciatoreInAsta
                      ? _c(
                          "span",
                          {
                            staticClass: "Ruolo ",
                            class: "Ruolo_" + _vm.ruoloCalciatoreInAsta,
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.ruolo(_vm.ruoloCalciatoreInAsta)) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("b", { staticClass: "asta-assegna-calciatore-name" }, [
                      _vm._v(_vm._s(_vm.nomeCalciatoreInAsta)),
                    ]),
                    _vm._v(" "),
                    _vm.nomeClubCalciatoreInAsta
                      ? _c("span", { staticClass: "asta-assegna-club" }, [
                          _vm._v(
                            "\n          (" +
                              _vm._s(_vm.nomeClubCalciatoreInAsta) +
                              ")\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [_vm._v(" - Assegna a...")]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pa-3 pb-2" },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "8" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.squadreDropdown,
                              "item-text": "name",
                              "item-value": "id",
                              "item-disabled": "disabled",
                              "menu-props": {
                                contentClass: "asta-assegna-squadre-menu",
                              },
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              label: "Seleziona squadra",
                              "no-data-text": "Nessuna squadra disponibile",
                              dark: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "selection",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "squadra-dropdown-selection",
                                        },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              staticClass: "mr-2",
                                              attrs: { size: "24" },
                                            },
                                            [
                                              _c("img", {
                                                attrs: { src: item.pic },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "squadra-dropdown-name",
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _c("v-list-item-avatar", [
                                        _c("img", { attrs: { src: item.pic } }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-content",
                                        {
                                          staticClass:
                                            "squadra-dropdown-item-content",
                                        },
                                        [
                                          _c("v-list-item-title", {
                                            staticClass:
                                              "squadra_name squadra-option-name",
                                            domProps: {
                                              textContent: _vm._s(item.name),
                                            },
                                          }),
                                          _vm._v(" "),
                                          item.disabledReason
                                            ? _c(
                                                "v-list-item-subtitle",
                                                {
                                                  staticClass:
                                                    "squadra-disabled-reason",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        item.disabledReason
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3656367904
                            ),
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-text-field", {
                            staticClass: "crediti-input",
                            attrs: {
                              value: _vm.offerta,
                              outlined: "",
                              dense: "",
                              readonly: "",
                              "hide-details": "",
                              label: "Costo",
                              "append-icon": "edit",
                              dark: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showNumpad()
                              },
                              "click:append": function ($event) {
                                return _vm.showNumpad()
                              },
                              keydown: function ($event) {
                                $event.preventDefault()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "px-2 py-1" },
                [
                  _vm.canAnnullaSelezione
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            rounded: "",
                            text: "",
                            small: "",
                            loading: _vm.processingAnnulla,
                            disabled: _vm.processing,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.annullaSelezione()
                            },
                          },
                        },
                        [_vm._v("Annulla")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { rounded: "", outlined: "", dark: "", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.scarta()
                        },
                      },
                    },
                    [_vm._v("Scarta")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-3 navy--text",
                      attrs: {
                        depressed: "",
                        rounded: "",
                        small: "",
                        color: "accent",
                        loading: _vm.loading,
                        disabled:
                          _vm.selected == null ||
                          _vm.offerta == null ||
                          _vm.squadraDisabled(_vm.selected),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.assegna()
                        },
                      },
                    },
                    [_vm._v("Assegna")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-2 pb-2" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-0",
                      attrs: { dense: "", text: "", color: "error" },
                      model: {
                        value: _vm.error,
                        callback: function ($$v) {
                          _vm.error = $$v
                        },
                        expression: "error",
                      },
                    },
                    [
                      _vm._v(
                        "\n        Offerta " +
                          _vm._s(_vm.errorValue) +
                          " non valida. Min: " +
                          _vm._s(_vm.minOfferta) +
                          " - Max:\n        " +
                          _vm._s(_vm.maxOfferta) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }